import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import { ReducerStatus, RootState } from '../types';
import { MyBookingCredentialsState } from './types';
import { MyBookingCredentials } from '@/api/MyBookingCredentials/myBookingCredentials.interfaces';

const initialState: MyBookingCredentialsState = {
    status: ReducerStatus.INITIAL,
    data: null,
};

const state: MyBookingCredentialsState = {
    ...initialState,
};

const getters: GetterTree<MyBookingCredentialsState, RootState> = {
    getCredentials(state): MyBookingCredentials | null {
        return state.data;
    },

    getIsLoggedIn(state): boolean {
        return state.data?.isLoggedIn ?? false;
    },
};

const actions: ActionTree<MyBookingCredentialsState, RootState> = {
    setStatusLoading({ state, commit }) {
        commit('setStatus', {
            ...state,
            status: ReducerStatus.LOADING,
        });
    },

    setStatusUpdating({ state, commit }) {
        commit('setStatus', {
            ...state,
            status: ReducerStatus.UPDATING,
        });
    },

    setStatusSuccess({ commit }, payload: MyBookingCredentials) {
        commit('setStatus', {
            ...state,
            status: ReducerStatus.LOADED,
            data: payload,
        });
    },

    setStatusError({ state, commit }) {
        commit('setStatus', {
            ...state,
            status: ReducerStatus.ERROR,
        });
    },
};

const mutations: MutationTree<MyBookingCredentialsState> = {
    setStatus(state: MyBookingCredentialsState, payload) {
        Object.assign(state, payload);
    },
};

export const myBookingCredentials: Module<MyBookingCredentialsState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
